export const richEditorStyles = theme => ({
    draftEditor: {
        margin: '18px auto',
        minHeight: 60,
    },
    container: {
        margin: '24px auto'
    },
    editorStyle: {
        boxSizing: 'border-box',
        border: `1px solid ${theme.palette.divider}`,
        cursor: 'text',
        padding: 16,
        borderRadius: 2,
        minHeight: 200,
        fontSize: 16
    }
});